export default "__VITE_ASSET__BNRni4nE__"